import produce from 'immer';
import { create } from 'zustand';

const useUserSkillsStore = create((set) => ({
  showEditor: false,
  skills: [],
  setShowEditor: (show, skills = []) =>
    set(
      produce((draft) => {
        draft.showEditor = show;
        draft.skills = skills;
      }),
    ),
}));

export default useUserSkillsStore;
